'use client';
import { useState, useEffect, useRef } from 'react';

const testimonials = [
{
  name: 'Amara Koné',
  role: 'Employé Groupe Cofina',
  text: 'Grâce au partenariat entre COSA et le Groupe Cofina, j\'ai bénéficié d\'un suivi médical complet et d\'un bilan annuel dans un cadre moderne et accueillant. Une expérience médicale unique en Côte d\'Ivoire.',
  img: "https://img.rocket.new/generatedImages/rocket_gen_img_102a58af8-1773132354083.png",
  alt: 'Femme africaine aux cheveux naturels souriant chaleureusement, témoignage patient'
},
{
  name: 'Kwame Asante',
  role: 'Chef d\'Entreprise',
  text: 'Le centre médical de Yopougon Ananeraie est devenu notre médecin référent. La qualité des soins, la modernité des installations et la disponibilité des spécialistes sont remarquables.',
  img: "https://img.rocket.new/generatedImages/rocket_gen_img_155090cba-1772078486983.png",
  alt: 'Homme africain avec lunettes souriant, témoignage patient'
},
{
  name: 'Fatou Diallo',
  role: 'Mère de famille',
  text: 'L\'espace ludique pour les enfants est une excellente initiative. Mon fils n\'a plus peur des consultations médicales. L\'équipe pédiatrique est très professionnelle et bienveillante.',
  img: "https://img.rocket.new/generatedImages/rocket_gen_img_155090cba-1772078486983.png",
  alt: 'Femme africaine en tenue professionnelle souriant, témoignage patient'
},
{
  name: 'Moussa Traoré',
  role: 'Diabétique suivi à COSA',
  text: 'Le suivi de ma diabétologie à COSA est exemplaire. Les médecins sont compétents, les analyses biomédicales réalisées en partenariat avec le Laboratoire Montagnier sont précises et rapides.',
  img: "https://img.rocket.new/generatedImages/rocket_gen_img_155090cba-1772078486983.png",
  alt: 'Homme africain aux cheveux courts souriant, témoignage patient'
},
{
  name: 'Adjoua Yao',
  role: 'Patiente en gynécologie',
  text: 'Un cadre soigné, des médecins à l\'écoute et des équipements modernes. COSA représente vraiment une nouvelle ère pour les soins de santé privés en Côte d\'Ivoire.',
  img: "https://img.rocket.new/generatedImages/rocket_gen_img_154785fed-1772421008997.png",
  alt: 'Femme africaine avec tresses souriant, témoignage patient'
},
{
  name: 'Kofi Mensah',
  role: 'Directeur RH, Entreprise Partenaire',
  text: 'Nous avons intégré COSA comme centre médical référent pour nos employés. Les bilans annuels, les vaccinations et les programmes de prévention ont considérablement amélioré la santé de notre équipe.',
  img: "https://img.rocket.new/generatedImages/rocket_gen_img_102a58af8-1773132354083.png",
  alt: 'Homme africain en chemise décontractée souriant, témoignage patient'
},
{
  name: 'Nkechi Okafor',
  role: 'Patiente en télémédecine',
  text: 'La télémédecine proposée par COSA m\'a permis d\'obtenir un diagnostic à distance lors d\'un déplacement. Un service innovant qui change vraiment la vie des patients.',
  img: "https://img.rocket.new/generatedImages/rocket_gen_img_102a58af8-1773132354083.png",
  alt: 'Femme africaine aux cheveux courts souriant professionnellement, témoignage patient'
},
{
  name: 'Seydou Coulibaly',
  role: 'Patient en médecine de proximité',
  text: 'Le service de médecine de proximité de COSA est exceptionnel. Le médecin s\'est déplacé à mon domicile pour un diagnostic. Un service unique et très professionnel en Côte d\'Ivoire.',
  img: "https://img.rocket.new/generatedImages/rocket_gen_img_155090cba-1772078486983.png",
  alt: 'Homme africain avec barbe souriant, témoignage patient'
},
{
  name: 'Awa Bamba',
  role: 'Bénéficiaire RSE COSA',
  text: 'COSA s\'engage auprès des enfants en difficulté sanitaire. Grâce à leur programme RSE, notre orphelinat bénéficie de prestations de santé régulières. Un engagement social remarquable.',
  img: "https://img.rocket.new/generatedImages/rocket_gen_img_113a39f47-1764658796265.png",
  alt: 'Femme africaine aux cheveux naturels souriant, témoignage patient'
}];


export default function TestimonialsSection() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const itemsPerView = 3;
  const maxIndex = testimonials.length - itemsPerView;
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setCurrentIndex((prev) => prev >= maxIndex ? 0 : prev + 1);
    }, 4000);
    return () => {if (intervalRef.current) clearInterval(intervalRef.current);};
  }, [maxIndex]);

  const goTo = (idx: number) => {
    setCurrentIndex(idx);
    if (intervalRef.current) clearInterval(intervalRef.current);
  };

  return (
    <section id="reviews-2" className="wide-100 bg-lightgrey">
      <div className="max-w-7xl mx-auto px-4">
        {/* TITLE */}
        <div className="text-center mb-12">
          <h3 className="text-3xl md:text-4xl font-black mb-4" style={{ color: '#1d3c5e', fontFamily: 'Lato, sans-serif' }}>
            Ce Que Disent Nos Patients
          </h3>
          <p className="text-gray-500 max-w-xl mx-auto">
            La satisfaction de nos patients est notre plus grande fierté. Découvrez leurs témoignages sur leur expérience à COSA Ananeraie.
          </p>
        </div>

        {/* CAROUSEL */}
        <div className="overflow-hidden">
          <div
            className="flex transition-transform duration-500"
            style={{ transform: `translateX(-${currentIndex * (100 / itemsPerView)}%)` }}>
            
            {testimonials.map((t, i) =>
            <div
              key={i}
              className="flex-shrink-0 px-3"
              style={{ width: `${100 / itemsPerView}%`, minWidth: `${100 / itemsPerView}%` }}>
              
                <div className="bg-white rounded-xl p-8 text-center shadow-md h-full">
                  {/* Quote icon */}
                  <div className="text-4xl mb-4" style={{ color: '#0e5932', opacity: 0.25 }}>
                    <i className="fas fa-quote-left"></i>
                  </div>

                  {/* Avatar */}
                  <div
                  className="w-16 h-16 rounded-full overflow-hidden mx-auto mb-4"
                  style={{ border: '3px solid #0e5932' }}>
                    <img
                    src={t.img}
                    alt={t.alt}
                    className="w-full h-full object-cover" />
                  </div>

                  {/* Text */}
                  <p className="text-sm text-gray-600 italic mb-5 leading-relaxed">{t.text}</p>

                  {/* Author */}
                  <div>
                    <h5 className="font-bold text-sm" style={{ color: '#1d3c5e' }}>{t.name}</h5>
                    <span className="text-xs font-semibold" style={{ color: '#0e5932' }}>{t.role}</span>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* DOTS */}
        <div className="flex justify-center gap-2 mt-8">
          {Array.from({ length: maxIndex + 1 }).map((_, i) =>
          <button
            key={i}
            onClick={() => goTo(i)}
            className="w-3 h-3 rounded-full transition-all border-none cursor-pointer"
            style={{ backgroundColor: i === currentIndex ? '#0e5932' : '#ddd' }}
            aria-label={`Aller au témoignage ${i + 1}`} />
          )}
        </div>
      </div>
    </section>);
}